import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle/apiHandle";
import { type_constant } from "../utils/asyncStatus";

// Get all notes
export const get_notes_list = createAsyncThunk(
  type_constant.GET_NOTES_LIST,
  async () => {
    try {
      const response = await apiHandle.get(`/admin/notes`);
      return {
        notes: response.data.data || response.data.notes || [],
        message: "Notes fetched successfully",
      };
    } catch (error) {
      console.log("error from get notes list", error);
      throw Error(error?.response?.data?.message || error.message);
    }
  }
);

// Get notes by user ID
export const get_notes_by_user = createAsyncThunk(
  type_constant.GET_NOTES_BY_USER,
  async (userId) => {
    try {
      const response = await apiHandle.get(`/admin/notes/user/${userId}`);
      return {
        notes: response.data.data || response.data.notes || [],
        message: "Notes fetched successfully",
      };
    } catch (error) {
      console.log("error from get notes by user", error);
      throw Error(error?.response?.data?.message || error.message);
    }
  }
);

// Search notes by user (client-side filter from all notes)
export const search_notes_by_user = createAsyncThunk(
  type_constant.SEARCH_NOTES_BY_USER,
  async (searchTerm, { getState }) => {
    try {
      const response = await apiHandle.get(`/admin/notes`);
      const allNotes = response.data.data || response.data.notes || [];
      const filtered = allNotes.filter(
        (note) =>
          note.user?.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          note.user?.last_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          note.user?.email?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      return {
        notes: filtered,
        message: "Notes searched successfully",
      };
    } catch (error) {
      console.log("error from search notes by user", error);
      throw Error(error?.response?.data?.message || error.message);
    }
  }
);

// Add new note
export const add_note_async = createAsyncThunk(
  type_constant.ADD_NOTE_ASYNC,
  async (noteData) => {
    try {
      const response = await apiHandle.post(`/admin/notes/save`, {
        user_id: noteData.userId,
        note: noteData.note,
      });
      return {
        note: response.data.data || response.data.note,
        message: response.data.message || "Note added successfully",
      };
    } catch (error) {
      console.log("error from add note", error);
      throw Error(error?.response?.data?.message || error.message);
    }
  }
);

// Edit note
export const edit_note_async = createAsyncThunk(
  type_constant.EDIT_NOTE_ASYNC,
  async ({ id, data }) => {
    try {
      const response = await apiHandle.post(`/admin/notes/save`, {
        id: id,
        user_id: data.userId,
        note: data.note,
      });
      return {
        note: response.data.data || response.data.note,
        message: response.data.message || "Note updated successfully",
      };
    } catch (error) {
      console.log("error from edit note", error);
      throw Error(error?.response?.data?.message || error.message);
    }
  }
);

// Delete note
export const delete_note_async = createAsyncThunk(
  type_constant.DELETE_NOTE_ASYNC,
  async (id) => {
    try {
      const response = await apiHandle.post(`/admin/notes/delete/${id}`);
      return {
        deletedNoteId: id,
        message: response.data.message || "Note deleted successfully",
      };
    } catch (error) {
      console.log("error from delete note", error);
      throw Error(error?.response?.data?.message || error.message);
    }
  }
);
